import React from 'react';
import { useSelector } from 'react-redux';
import utils from '../../utils';
import HotspotAdaptor from './hotspotAdaptor';

const Hotspots = props => {
    const currentFrame = useSelector(state => state.video.currentFrame);
    const isImage = useSelector(state => state.options.isImage);

    const spritesOnDemand = useSelector(state => {
        return state.hotspots.sprites.filter(spriteId => {
            if (isImage) return true; // Show all hotspots on Interactive Image

            const { inFrame, outFrame } = state.hotspots.spriteConnections[spriteId];
            const onDemand = utils.isVisible(currentFrame, inFrame, outFrame);

            return onDemand;
        });
    });

    if (!spritesOnDemand) return null;

    return (
        <>
            {spritesOnDemand.map(spriteId => (
                <HotspotAdaptor key={spriteId} spriteId={spriteId} {...props} />
            ))}
        </>
    );
};

export default Hotspots;
